<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/66kzqt/images/cover.jpg?1733151160709" alt="This image is the cover for the book Serpent Mage, Songs of Earth and Power"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serpent Mage, Songs of Earth and Power
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>New York Times</i>–bestselling and award-winning author of <i>The Infinity Concerto</i>, the fantasy saga continues . . .</b><br/>  <br/> After five years trapped in the Realm of the Sidhedark, Michael Perrin has returned home. He wants nothing more than to live a normal life—but the unearthly music of Arno Waltiri continues to play on.<br/>  <br/> The song of power has weakened the veil between the human and faerie worlds. The streets of Los Angeles are haunted by uncanny beings, strange bodies have been discovered in a dilapidated hotel, and an ancient creature calls to Michael from the waters of a loch in Scotland.<br/>  <br/> The Sidhe have followed Michael home. To repair the rift between Earth and Realm, man and fae, he will have to wield the magic he wished he never learned—and complete an unfinished symphony linked to the ethereal melody of Waltiri’s Opus 45, the Infinity Concerto.<br/>  <br/> This follow-up to <i>The Infinity Concerto</i> is a work of fresh, out-of-the-ordinary fantasy by an acclaimed winner of the Nebula and Hugo Awards, the author of <i>The Forge of God</i>, the Forerunner Saga, and other reader favorites.<br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Bear
      </h2>
      
      <p class="authorDescription body article">&amp;lt;B&amp;gt;Greg Bear&amp;lt;/B&amp;gt; is the author of more than thirty books of science fiction and fantasy, including &amp;lt;I&amp;gt;Forerunner: Cryptum, Mariposa, Darwin's Radio, Eon&amp;lt;/I&amp;gt;, and &amp;lt;I&amp;gt;Quantico&amp;lt;/I&amp;gt;. He is married to Astrid Anderson Bear and is the father of Erik and Alexandra. His works have been published internationally in over twenty languages. Bear has been called the "Best working writer of hard science fiction" by the &amp;lt;I&amp;gt;Ultimate Encyclopedia of Science Fiction&amp;lt;/I&amp;gt;.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ac1d136